import { Step } from '@main/mobile-menu/const';
import { MobileMenuActions } from '../actions';
import { MobileMenuData } from '../mobile-menu-state';

export const initialState: MobileMenuData = {
  steps: [],
  depth: 0,
};

const depthAdapter = (state: MobileMenuData): number => {
  if (state.depth < state.steps.length) {
    return state.depth + 1;
  }

  return state.depth;
};

const stepAdapter = (depth: number, steps: Step[], payload: Step): Step[] => {
  const newStep = [...steps];
  if (steps.length >= depth) {
    newStep[depth] = payload;

    return newStep;
  }

  return [...steps, payload];
};

export function reducer(
  state = initialState,
  action:
    | MobileMenuActions.MobileMenuNextStep
    | MobileMenuActions.MobileMenuPrevStep
    | MobileMenuActions.MobileMenuResetSteps
    | MobileMenuActions.MobileMenuSetState
    | MobileMenuActions.MobileMenuSimpleForward,
): MobileMenuData {
  switch (action.type) {
    case MobileMenuActions.MOBILE_MENU_SIMPLE_NEXT_STEP: {
      return {
        ...state,
        depth: depthAdapter(state),
      };
    }

    case MobileMenuActions.MOBILE_MENU_NEXT_STEP: {
      return {
        ...state,
        steps: stepAdapter(state.depth, state.steps, action.payload),
        depth: state.depth + 1,
      };
    }

    case MobileMenuActions.MOBILE_MENU_PREV_STEP: {
      return {
        ...state,
        depth: state.depth - 1 || 1,
      };
    }

    case MobileMenuActions.MOBILE_MENU_RESET_STEPS: {
      return initialState;
    }

    case MobileMenuActions.MOBILE_MENU_SET_STATE: {
      return action.payload;
    }

    default: {
      return state;
    }
  }
}
